import type { FunctionComponent } from 'react';
import type { ITooltipContent } from '../../../interfaces/chart';
import type { RoadmapEvent } from '../../../interfaces/event';
import { CashEventTooltipContent } from './CashEventTooltipContent';

const PAPER_WIDTH = 260;
const PAPER_MAX_HEIGHT = 350;
const HEADER_HEIGHT = 124;
const PAGE_HEADER_HEIGHT = 164;
const Y_OFFSET = 300;
const X_OFFSET = 60;
const X_THRESHOLD = 170; // To check if the tooltip is positioned left or right of cursor

interface IProps {
    events: RoadmapEvent[];
    showDetails?: boolean;
    handleClose: () => void;
    tooltipContent: ITooltipContent;
    openModal?: (event: RoadmapEvent) => void;
}

export const CashEventList: FunctionComponent<IProps> = ({ handleClose, tooltipContent, openModal, ...props }) => (
    <div className="cash-event-list" onClick={handleClose}>
        <div
            className="cash-event-list__container"
            style={{
                left: `calc(${tooltipContent.position.x}px ${tooltipContent.position.x < X_THRESHOLD ? '+' : `- ${X_OFFSET}px -`} ${PAPER_WIDTH / 2}px)`,
                bottom: `calc(100vh - ${HEADER_HEIGHT}px - ${PAGE_HEADER_HEIGHT}px - ${Y_OFFSET}px - ${tooltipContent.position.y}px)`,
                maxWidth: PAPER_WIDTH,
                maxHeight: PAPER_MAX_HEIGHT,
            }}
            onClick={(e) => e.stopPropagation()}
        >
            <CashEventTooltipContent {...props} openModal={openModal} tooltipContent={tooltipContent} handleClose={handleClose} />
        </div>
    </div>
);
